module.exports = __webpack_public_path__ + "static/media/football-player-main.3f9afb7d.png";